var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { autorun } from 'mobx';

import { userStore } from 'sdc-auth-user';
import { StandardStore } from 'sdc-mobx-stores';
import { requiredParam } from 'sdc-utilities';

import api from './api';

export var SpacesStore = function (_StandardStore) {
  _inherits(SpacesStore, _StandardStore);

  function SpacesStore(_ref) {
    var _ref$typesStore = _ref.typesStore,
        typesStore = _ref$typesStore === undefined ? requiredParam('typesStore') : _ref$typesStore,
        _ref$typesStoreCE = _ref.typesStoreCE,
        typesStoreCE = _ref$typesStoreCE === undefined ? requiredParam('typesStoreCE') : _ref$typesStoreCE,
        options = _objectWithoutProperties(_ref, ['typesStore', 'typesStoreCE']);

    _classCallCheck(this, SpacesStore);

    var _this = _possibleConstructorReturn(this, _StandardStore.call(this, _extends({}, options, {
      listName: 'spaces',
      entryName: 'space'
    })));

    _this.afterSelect = function (space) {
      _this.typesStore.setSpaceID(space.key);
      _this.typesStoreCE.setSpaceID(space.key);
    };

    _this.typesStore = typesStore;
    _this.typesStoreCE = typesStoreCE;

    autorun(function () {
      if (userStore.user.id) {
        _this.list({})();
      } else {
        _this.clearEntries();
      }
    });
    return _this;
  }

  return SpacesStore;
}(StandardStore);

export default (function (_ref2) {
  var backend = _ref2.backend,
      options = _objectWithoutProperties(_ref2, ['backend']);

  return new SpacesStore(_extends({}, options, { api: api({ backend: backend }) }));
});